// plan-12 S03: H-sync glitch — Poisson-distributed rare CRT glitch

import type { DrawPass } from '../canvas'
import { setPortalAmpMultiplier } from './standingWave'

// Poisson: lambda = 1/60 per second → mean interval = 60s
const LAMBDA_INV = 60_000
const EVENT_DURATION = 240
const MIN_COOLDOWN = 20_000
const MAX_SESSION_EVENTS = 9

let sessionCount = 0

export function createHsyncGlitch(reduced: boolean): DrawPass {
  if (reduced) return () => {}

  let nextEvent = performance.now() + nextPoisson()
  let eventStart = 0
  let active = false
  let cooldownUntil = 0

  function nextPoisson(): number {
    const u = Math.random()
    return -LAMBDA_INV * Math.log(u)
  }

  return (_ctx, _w, _h, t): void => {
    const now = t * 1000
    const main = document.getElementById('vt-app')

    if (!main) return

    if (!active && now >= nextEvent && now >= cooldownUntil && sessionCount < MAX_SESSION_EVENTS) {
      active = true
      eventStart = now
      sessionCount++

      // choose random shift direction
      const shift = Math.random() < 0.5 ? -2 : 2
      main.style.setProperty('--vt-hsync-shift', shift + 'px')
      main.classList.add('vt-hsync-active')

      // double standing wave amplitude for 240ms
      setPortalAmpMultiplier(2)

      // trigger drift jump in status bar vitals
      import('../../oracle/layout').then(({ glitchDrift, dropSignalStrength }) => {
        glitchDrift()
        dropSignalStrength()
      }).catch(() => {})

      // plan-17 S04: notify drone of H-sync for retune chirp cooldown
      import('../../audio/drone').then(({ markHsyncGlitch }) => {
        markHsyncGlitch()
      }).catch(() => {})

      // play glitch click (reuse command_reject at -12 dB via dynamic import)
      import('../../audio/sfx').then(({ play }) => {
        play('command_reject')
      }).catch(() => {})
    }

    if (active) {
      const elapsed = now - eventStart
      if (elapsed >= EVENT_DURATION) {
        active = false
        cooldownUntil = now + MIN_COOLDOWN
        nextEvent = now + nextPoisson()

        main.classList.remove('vt-hsync-active')
        main.style.removeProperty('--vt-hsync-shift')
        setPortalAmpMultiplier(1)
      }
    }
  }
}
